'use strict';

exports.__esModule = true;
var DOCTIFY_PHONE = exports.DOCTIFY_PHONE = '+44 20 3411 0652';
var DOCTIFY_HELLO_EMAIL = exports.DOCTIFY_HELLO_EMAIL = 'hello@doctify.co.uk';
var DOCTIFY_ADDRESS_SINGLE_LINE = exports.DOCTIFY_ADDRESS_SINGLE_LINE = 'Mail us at Doctify, Triangle Building Stables Market, Chalk Farm Rd, London NW1 8AB';
var DOCTIFY_ADDRESS_MULTILINE = exports.DOCTIFY_ADDRESS_MULTILINE = 'Triangle Building <br/> Stables Market <br/> Chalk Farm Road <br/> London NW1 8AB <br/> United Kingdom';


// WEBPACK FOOTER //
// ./components/info-page/lib/utils/constants.js